
import {
  INIT_CATEGORY_INFO,
  REQUEST_CATEGORY_START,
  REQUEST_CATEGORY_SUCCESS,
  REQUEST_CATEGORY_FAIL,
} from '../actions/category';

export const initialState = { error: null, data: null, isLoading: false }

export const reducer = (state = initialState, action) => {

  const { type, data, payload, error } = action;

  switch (type) {

    case REQUEST_CATEGORY_START:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.req, isLoading: true, type } }
      }

    case REQUEST_CATEGORY_SUCCESS:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    case REQUEST_CATEGORY_FAIL:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    case INIT_CATEGORY_INFO:
      {
        return initialState;
      }

    default:
      {
        return { ...state };
      }
  }
};

export default reducer;
